import { MYBID_LIST } from "../actions";

export function myBid(state = [], action) {
  switch (action.type) {
    case MYBID_LIST:
      return action.payload;
    default:
      return state;
  }
}
